import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
export type DefaultCarrierEntryFragmentFragment = { __typename?: 'DefaultCarrierEntry', carrier_service: Types.OpsOrderCarrierService, carrier: Types.OpsOrderCarrier };

export const DefaultCarrierEntryFragmentFragmentDoc = gql`
    fragment DefaultCarrierEntryFragment on DefaultCarrierEntry {
  carrier_service
  carrier
}
    `;